export default __webpack_public_path__ + "static/media/trac_8.31671e66.png";